import type { ReactNode } from 'react';

import { Card as MuiCard, CardContent, styled } from '@mui/material';

type Props = {
  children: ReactNode;
};

const StyledMuiCard = styled(MuiCard)`
  border-radius: 22px;
`;

export const CardRounded = ({ children }: Readonly<Props>) => {
  return (
    <StyledMuiCard variant="outlined">
      <CardContent>{children}</CardContent>
    </StyledMuiCard>
  );
};
